import classNames from "classnames";
import { observer } from "mobx-react-lite";
import { FormField } from "../../../../ui-kit";
import DefectRegister from "../../../../store/defectRegister";

const Search = observer(
  ({
    value,
    onChange,
  }: {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  }) => {
    const searchClassNames = classNames("address-search", {
      "address-search--opened": !DefectRegister.siderCollapsed,
    });

    return (
      <div className={searchClassNames}>
        <FormField
          label="Поиск по адресу"
          name="search"
          type="text"
          currentValue={value}
          onChange={onChange}
        />
      </div>
    );
  },
);

export default Search;
